import React from 'react';

const ListObjectsCellRenderer = ({value}) => {
    const valueString  = value ? value.map(item => item.name).join(' | ') : ""
    return (<span className="ag-cell-truncate" title={valueString}>{valueString}</span>);
};

export default ListObjectsCellRenderer;